import { jsx as _jsx } from "react/jsx-runtime";
export const FilterFormWrapper = ({ children, onSubmit, }) => {
    return (_jsx("form", { id: "notificationFilterForm", "data-testid": "filterForm", onSubmit: onSubmit, children: children }));
};
